import { EntRealEstateFilter } from "../../../models/filters/realEstateFilter";
import { EntRealEstate } from "../../../models/realEstate";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { RealEstateForYearResponse, StatisticsResponse, ConditionResponse } from "../../../components/generaldata/generaldatapages/immovable/types";
import moment from "moment";
import { EntRealEstateReportPayload } from "../../../models/realEstateReport";
import { BlobResponse } from "../../../models/report";
import { Paths } from "../../../paths";

interface GetEstateAnalyticaForYearParams {
    governmentId: number;
    year: number;
}

interface GetEstateAnalyticalPurposeOwnershipParams {
    governmentAlias: string;
    year: number
}

export const realEstateApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getRealEstateListAll: builder.query<ResponseDataGet<EntRealEstate>, EntRealEstateFilter>({
      query: (filter) => ({
        url: `${ Paths.registries.realestateregister }/get-all`,
        method: "POST",
       body: JSON.stringify(filter, (key, value) => {
                if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
                  return moment(value).format('YYYY-MM-DD')
                }
                return value;
              })
      }),
    }),
    getEstateAnalyticaForYearData: builder.query<RealEstateForYearResponse, GetEstateAnalyticalPurposeOwnershipParams>({
      query: ({ governmentAlias, year }) => ({
        url: `${ Paths.registries.realestateregister }/analytical-data/for-year`,
        method: 'GET',
        params: {
          governmentAlias,
          year
        }
      })
    }),

        getEstateAnalyticalPurposeOwnershipData: builder.query<StatisticsResponse, GetEstateAnalyticalPurposeOwnershipParams>({
            query: ({ governmentAlias }) => ({
                url: `${ Paths.registries.realestateregister }/analytical-data/purpose-and-ownership`,
                method: 'GET',
                params: {
                  governmentAlias
                }
            })
        }),

        getEstateAnalyticalbyconditionData: builder.query<ConditionResponse, GetEstateAnalyticalPurposeOwnershipParams>({
            query: ({ governmentAlias }) => ({
                url: `${ Paths.registries.realestateregister }/analytical-data/by-condition`,
                method: 'GET',
                params: {
                  governmentAlias
                }
            })
        }),

    getRealEstateById: builder.query<ResponseDataTest<EntRealEstate>, number>({
      query: (id) => ({
        url: `${ Paths.registries.realestateregister }/${id}`,
        method: 'GET'
      })
    }),
    addRealEstate: builder.mutation<ResponseDataTest<EntRealEstate>, EntRealEstate>({
      query: (body) => ({
        url: `${ Paths.registries.realestateregister }`,
        method: "POST",
      body: JSON.stringify(body, (key, value) => {
               if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
                 return moment(value).format('YYYY-MM-DD')
               }
               return value;
             })
      }),
    }),
    editRealEstate: builder.mutation<ResponseDataTest<EntRealEstate>, EntRealEstate>({
      query: (body) => ({
        url: `${ Paths.registries.realestateregister }`,
        method: 'PUT',
        body: JSON.stringify(body, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return moment(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    deleteRealEstate: builder.mutation<ResponseDataTest<EntRealEstate>, number>({
      query: (id) => ({
        url: `${ Paths.registries.realestateregister }/${id}`,
        method: 'DELETE',
      }),
    }),
    getReportRealEstate: builder.mutation<BlobResponse, EntRealEstateReportPayload>({
      query: (payload) => {
        const { language, governmentAlias } = payload;

        return {
          url: `/report${ Paths.registries.realestateregister }`,
          method: "POST",
          params: {
            language,
            governmentAlias,
          },
          body: JSON.stringify(payload),
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
    useGetReportRealEstateMutation,
    useAddRealEstateMutation,
    useDeleteRealEstateMutation,
    useEditRealEstateMutation,
    useLazyGetRealEstateListAllQuery,
    useGetEstateAnalyticaForYearDataQuery,
    useGetEstateAnalyticalPurposeOwnershipDataQuery,
    useGetEstateAnalyticalbyconditionDataQuery,
} = realEstateApi;
